module.exports = __webpack_public_path__ + "img/Caracteristicas departamento.d2be167d.png";